<template>
  <div class="filter-bar">
    <div
      v-for="filter in parsedFilters"
      :key="filter.label"
      class="filter-item"
    >
      <div class="filter-item__label" @click="onFilterClick(filter)">
        <span>{{ getFilterLabel(filter) }}</span>
        <span class="caret"></span>
      </div>
      <select
        class="filter-item__select"
        v-if="filter.options"
        v-model="filter.value"
        @change="onChange(filter)"
      >
        <option
          v-for="option in filter.options"
          :key="option.label"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import dateFilter from "@/components/filter/date.js";
import periodFilter from "@/components/filter/period.js";
import currencyFilter from "@/components/filter/currency.js";
import sellerFilter from "@/components/filter/seller.js";
import comboFilter from "@/components/filter/combo.js";

export default {
  props: {
    filters: Array,
  },
  data() {
    return {
      parsedFilters: [],
      defaults: {
        /** 默认的日期筛选选项 **/
        date: dateFilter,
        /** 默认的期间筛选选项 **/
        period: periodFilter,
        /** 默认的币种筛选选项 **/
        currency: currencyFilter,
        /** 默认的下拉框筛选选项 **/
        combo: comboFilter,
        /** 默认的业务员筛选选项 **/
        seller: sellerFilter,
      },
    };
  },
  created() {
    this.initConfig();
  },
  methods: {
    initConfig() {
      var me = this,
        filters = me.filters,
        defaults = me.defaults;
      me.parsedFilters = filters.map((filter) => {
        if (filter.type && defaults[filter.type]) {
          filter = Object.assign({}, defaults[filter.type], filter);
        }
        // 初始化方法
        if (filter.init) {
          filter.init.call(me, filter, me);
        }
        return filter;
      });
    },
    getFilterLabel(filter) {
      var me = this,
        value = filter.value,
        options = filter.options,
        option;
      // 基于renderer方法显示label
      if (filter.renderer) {
        return filter.renderer.call(me, filter);
      }
      // 基于下拉选项值显示label
      if (value != undefined && options) {
        option = options.find((option) => option.value == value);
        if (option) {
          return option.label;
        }
      }
      return filter.label;
    },
    onChange(filter) {
      var me = this;
      if (filter.beforeChange) {
        // 支持change前置动作
        filter.beforeChange(filter, me, () => {
          me.$emit("change");
          me.$forceUpdate();
        });
      } else {
        me.$emit("change");
        me.$forceUpdate();
      }
    },
    getCondition() {
      var me = this,
        filters = me.parsedFilters,
        conditions = [],
        value,
        option;
      filters.forEach((filter) => {
        value = filter.value;
        if (value != undefined) {
          var condition;
          // 自定义取条件的方法
          if (filter.fn) {
            condition = filter.fn(value, filter, me);
          } else if (filter.type) {
            // 按条件类型
            switch (filter.type) {
              case "condition":
                option = filter.options.find((option) => option.value == value);
                if (option && option.condition) {
                  condition = {
                    type: "condition",
                    value: option.condition,
                  };
                }
                break;
              default:
                condition = {
                  field: filter.name,
                  operation: "=",
                  value,
                };
            }
          } else {
            condition = {
              field: filter.name,
              operation: "=",
              value,
            };
          }
          if (condition) {
            conditions.push(condition);
          }
        }
      });
      return conditions;
    },
    getMode() {
      var me = this,
        filters = me.parsedFilters,
        mode = "MAIN";
      filters.forEach((filter) => {
        if (filter.options) {
          var opt = filter.options.find(
            (option) => option.value == filter.value
          );
          if (null != opt && opt.mode) {
            mode = opt.mode;
            return false;
          }
        }
      });
      return mode;
    },
    /**
     * 针对filter没有options情况，
     * 例如选择具体期间
     */
    onFilterClick(filter) {
      var me = this,
        handler = filter.handler;
      if (handler) {
        handler.call(me, filter, me);
      }
    },
  },
};
</script>

<style scoped>
.filter-bar {
  /* background: #fff; */
  background: var(--weui-BG-2);
  position: relative;
  box-sizing: border-box;
  display: flex;
}
.filter-item {
  flex: 1;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  position: relative;
}
.filter-item__label {
  text-align: center;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.filter-bar:after {
  content: " ";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-bottom: 1px solid #d7d6dc;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.filter-bar + .list.weui-cells:before {
  content: none;
}
</style>